import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type UserActivationFailedAction = {
	type: 'USER_ACTIVATION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): UserActivationFailedAction => ({
	type: 'USER_ACTIVATION_FAILED',
	payload,
});
